// packages/web/src/lib/plan-entry-save.ts
export interface EntryBefore {
  startAt: number;
  endAt: number;
  workorderId: string | null;
  craneId: string | null;
  note: string;
  dayBreakId: string | null;
  dayBreakMinutes: number;
}
export type EntryAfter = EntryBefore;

export type SaveStep =
  | {
      op: "update";
      body: {
        startAt: number;
        endAt: number;
        workorderId: string | null;
        craneId: string | null;
        note: string;
      };
    }
  | { op: "updateDayBreak"; id: string; body: { minutes: number } };

function entryChanged(b: EntryBefore, a: EntryAfter): boolean {
  return (
    b.startAt !== a.startAt ||
    b.endAt !== a.endAt ||
    b.workorderId !== a.workorderId ||
    b.craneId !== a.craneId ||
    b.note !== a.note
  );
}

export function planEntrySave(before: EntryBefore, after: EntryAfter): SaveStep[] {
  const steps: SaveStep[] = [];
  if (entryChanged(before, after)) {
    steps.push({
      op: "update",
      body: {
        startAt: after.startAt,
        endAt: after.endAt,
        workorderId: after.workorderId,
        craneId: after.craneId,
        note: after.note,
      },
    });
  }
  if (before.dayBreakMinutes !== after.dayBreakMinutes && after.dayBreakId) {
    steps.push({
      op: "updateDayBreak",
      id: after.dayBreakId,
      body: { minutes: after.dayBreakMinutes },
    });
  }
  return steps;
}
